module.exports = __webpack_public_path__ + "img/forgot-password-v2.1cc0a523.svg";